export const checkHistoryDisplay = `${process.env.REACT_APP_CU_IRB_API_URL}/history/checkDisplay`